import React, { useEffect } from "react";
import { styled } from "styled-components";
import {
  AlmahaLogo,
  AmusementParkImage,
  AmusementParkImage1,
  AmusementParkImage2,
  BannerMobile1,
  BannerMobile2,
  BannerMobile3,
  BannerWeb1,
  BannerWeb2,
  BannerWeb3,
} from "../../assets/images";
import { Colors } from "../../ColorConstants";
import { Text } from "../../TextConstants";
import Button from "../Buttons";
import { useNavigate } from "react-router-dom";
import {
  ArrowDown,
  MyCart,
  Calendar,
  Logout,
  Login,
  SignUp,
} from "../../assets/icons";
import { useState } from "react";
import MenuContent from "./MenuModalContent";
import MobileButtonContainer from "./MobileContainer";
import { trackFBEvent } from "../../analytics";
import { EVENT } from "../../analytics/constants";

const Banner = ({ showCart, count, loginName }) => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const images = isMobile
    ? [BannerMobile1, BannerMobile2, BannerMobile3]
    : [BannerWeb1, BannerWeb2, BannerWeb3];
  const navigate = useNavigate();
  const type = localStorage.getItem("type");
  const name = localStorage.getItem("name");
  const showLogin = type === null || type === "guest";
  const [menuModal, setMenuModal] = useState(false);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  useEffect(() => {
    const intervalId = setInterval(() => {
      setCurrentImageIndex((prevIndex) =>
        prevIndex === images.length - 1 ? 0 : prevIndex + 1
      );
    }, 5000);

    return () => clearInterval(intervalId);
  }, []);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    window.addEventListener("resize", handleResize); // Cleanup the event listener on component unmount
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const handleDotClick = (index) => {
    setCurrentImageIndex(index);
  };

  const closeModal = () => {
    setMenuModal(false);
  };
  const onClickLogout = () => {
    trackFBEvent(EVENT.LOGOUT, { name });
    localStorage.removeItem("token");
    localStorage.removeItem("type");
    localStorage.removeItem("name");
    localStorage.removeItem("refreshToken");
    navigate("/auth/login");
  };
  const onClickReservation = () => {
    navigate("/app/reservation");
  };
  const onClickLogin = () => {
    navigate("/auth/login");
  };
  const onClickSignup = () => {
    navigate("/auth/signup");
  };

  return (
    <BannerContainer>
      <StyledBanner
        currentIndex={currentImageIndex}
        onClick={closeModal}
        images={images}
      >
        <BannerImages src={images[currentImageIndex]} />
        <HelloText>
          <LogoImage src={AlmahaLogo} alt="Almaha Logo" />
          {(loginName || name) && (
            <>
              <Divider />
              <HelloSpan>Hi,</HelloSpan>{" "}
              <NameSpan>
                {loginName?.split(" ")[0] || name?.split(" ")[0]}
              </NameSpan>
            </>
          )}
        </HelloText>
      </StyledBanner>
      <Dots>
        {images.map((_, index) => (
          <Dot
            key={index}
            active={index === currentImageIndex}
            onClick={() => handleDotClick(index)}
          />
        ))}
      </Dots>
      {showLogin ? (
        <>
          <ButtonContainer showCart={showCart}>
            <ButtonWrapper>
              {showCart === true ? (
                <Button
                  label="My Cart"
                  variant="filled"
                  backgroundColor={Colors.greenlandGreen}
                  size="large"
                  fontColor={Colors.white}
                  padding={"0.2rem 1rem"}
                  cursorType="pointer"
                  onClick={(e) => {
                    navigate("/app/cart");
                  }}
                  width="100%"
                  startIcon={<MyCartImage src={MyCart} marginRight="0.3rem" />}
                />
              ) : null}
              <Button
                label="Menu"
                variant="filled"
                backgroundColor={Colors.white}
                size="large"
                padding={showCart ? "0.2rem 0.5rem" : "0.2rem 1.5rem"}
                fontColor={Colors.aqua}
                onClick={(e) => {
                  setMenuModal(!menuModal);
                }}
                endIcon={<MyCartImage src={ArrowDown} marginRight="0" />}
                width="70%"
              />
              {/* <Button
              label="Login"
              variant="filled"
              backgroundColor={Colors.white}
              size="large"
              fontColor={Colors.aqua}
              padding={"0.5rem 1rem"}
              cursorType="pointer"
              onClick={(e) => {
                navigate("/auth/login");
              }}
            />
            <Button
              label="SignUp"
              variant="filled"
              backgroundColor={Colors.white}
              size="large"
              padding={"0.5rem 1rem"}
              fontColor={Colors.aqua}
              onClick={(e) => {
                navigate("/auth/signup");
              }}
            /> */}
            </ButtonWrapper>
          </ButtonContainer>
          <MobileButtonContainer
            showCart={showCart}
            cartNumber={count}
            onClickButton1={() => {
              navigate("/app/cart");
            }}
            onClickButton2={() => {
              setMenuModal(!menuModal);
            }}
          />
        </>
      ) : (
        <>
          <ButtonContainer>
            <ButtonWrapper>
              {showCart === true ? (
                <Button
                  label="My Cart"
                  variant="filled"
                  backgroundColor={Colors.greenlandGreen}
                  size="large"
                  fontColor={Colors.white}
                  padding={"0.2rem 1rem"}
                  cursorType="pointer"
                  onClick={(e) => {
                    navigate("/app/cart");
                  }}
                  width="100%"
                  startIcon={<MyCartImage src={MyCart} marginRight="0.3rem" />}
                />
              ) : null}
              <Button
                label="Menu"
                variant="filled"
                backgroundColor={Colors.white}
                size="large"
                padding={showCart ? "0.2rem 0.5rem" : "0.2rem 1.5rem"}
                fontColor={Colors.aqua}
                onClick={(e) => {
                  setMenuModal(!menuModal);
                }}
                endIcon={<MyCartImage src={ArrowDown} marginRight="0" />}
                width="70%"
              />
              {/* <Button
              label="Logout"
              variant="filled"
              backgroundColor={Colors.white}
              size="large"
              padding={"0.5rem 1rem"}
              fontColor={Colors.aqua}
              onClick={(e) => {
                localStorage.removeItem("token");
                localStorage.removeItem("type");
                localStorage.removeItem("name");
                navigate("/auth/login");
              }}
              width='70%'
            /> */}
            </ButtonWrapper>
          </ButtonContainer>
          <MobileButtonContainer
            showCart={showCart}
            cartNumber={count}
            onClickButton1={() => {
              navigate("/app/cart");
            }}
            onClickButton2={() => {
              setMenuModal(!menuModal);
            }}
          />
        </>
      )}
      {menuModal && (
        <ModalContainer>
          {showLogin ? (
            <MenuContent
              showLogin={showLogin}
              onClickOption1={onClickLogin}
              onClickOption2={onClickSignup}
              image1={Login}
              image2={SignUp}
            />
          ) : (
            <MenuContent
              showLogin={showLogin}
              onClickOption1={onClickReservation}
              onClickOption2={onClickLogout}
              image1={Calendar}
              image2={Logout}
            />
          )}
        </ModalContainer>
      )}
    </BannerContainer>
  );
};

const BannerContainer = styled.div`
  position: relative;
`;

const StyledBanner = styled.div`
  position: relative;
  height: 35rem;
  overflow: hidden;

  &:before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 4rem;
    background: linear-gradient(
      to bottom,
      rgba(0, 0, 0, 0.2) 0%,
      rgba(0, 0, 0, 0.2) 100%
    );
    @media (max-width: 43.75rem) {
      height: 3rem;
    }
  }
  // background-image: url(${(props) => props.images[props.currentIndex]});
  // background-repeat: no-repeat;
  // background-size: cover;
  display: flex;
  // background-color: black;
  // background-position: center center;
  justify-content: center;
  // padding: 4.5rem 0;
  box-sizing: border-box;
  // transition: background-image 1s ease;
  position: relative;
  align-items: center;

  @media (max-width: 43.75rem) {
    height: 18rem;
    background-size: cover;
    background-position: center;
  }
`;
const BannerImages = styled.img`
  width: 100%;
  height: 100%;
  resize-mode: contain;
`;
const Dots = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 1rem;
`;

const Dot = styled.div`
  width: 0.625rem;
  height: 0.625rem;
  background-color: ${(props) => (props.active ? Colors.aqua : Colors.ePink)};
  border-radius: 50%;
  margin: 0 0.313rem;
  cursor: pointer;
`;

const TextDiv = styled.div`
  text-align: center;
`;

const TitleText = styled.span`
  display: block;
  color: ${Colors.white};
  font-family: Poppins;
  font-size: 3.875rem;
  font-style: normal;
  font-weight: 700;
  text-shadow: 0px 0px 10px rgba(0, 0, 0, 0.45);
  @media (max-width: 43.75rem) {
    font-size: 1.2rem;
    padding: 0rem 2.2rem;
  }
`;

const DetailText = styled(TitleText)`
  font-size: 1.3rem;
  font-weight: 500;
  text-align: center;
  padding: 0 3.125rem;
  text-shadow: 0px 0px 10px rgba(0, 0, 0, 0.45);
  @media (max-width: 43.75rem) {
    font-size: 1rem;
    display: none;
  }
`;

const ButtonContainer = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  margin-inline-end: 1rem;
  margin-top: 1.1rem;
  @media (max-width: 500px) {
    display: none;
  }
`;

const ButtonWrapper = styled.div`
  display: flex;
  justify-content: ${(props) => (props.showCart ? "center" : "flex-end")};
  gap: 1rem;
`;

const ModalContainer = styled.div`
  position: absolute;
  top: 2.3rem;
  right: 0;
  margin: 1rem;
  background-color: rgba(255, 255, 255, 1);
  @media (max-width: 500px) {
    top: 3rem;
    width: 100%;
    margin-right: 0rem;
    background-color: rgba(255, 255, 255, 0.9);
  }
`;

const MyCartImage = styled.img`
  width: 1.1rem;
  height: 1.1rem;
  margin-right: ${(props) => props.marginRight};
`;

const HelloText = styled.div`
  display: flex;
  position: absolute;
  top: 0;
  left: 0;
  margin: 1rem;
  color: ${Colors.white};
  font-family: Poppins;
  margin-top: 1rem;
  align-items: center;
  flex-direction: row;
  @media (max-width: 43.75rem) {
    margin-top: 0.5rem;
  }
`;

const HelloSpan = styled.span`
  color: ${Colors.white};
  font-family: Poppins;
  font-size: 1.5rem;
  font-weight: 300;
  @media (max-width: 43.75rem) {
    font-size: 1rem;
  }
`;

const NameSpan = styled.span`
  color: ${Colors.white};
  font-family: Poppins;
  font-size: 1.5rem;
  font-weight: 500;
  margin-left: 0.6rem;

  @media (max-width: 43.75rem) {
    font-size: 1rem;
  }
`;

const LogoImage = styled.img`
  width: 8rem;
  margin-left: 2rem;
  margin-top: 0.3rem;
  @media (max-width: 43.75rem) {
    width: 4rem;
    margin-left: 0.2rem;
  }
`;
const Divider = styled.div`
  height: 2rem;
  width: 0.05rem;
  background-color: white;
  margin: 0 1.8rem;
  @media (max-width: 43.75rem) {
    margin: 0 1rem;
    width: 0.02rem;
  }
`;

export default Banner;
